var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.lodash.isEmpty(_vm.medicalRequestsQueue))?_c('MedicalRequestList',{attrs:{"attendance":_vm.attendance,"exams":_vm.medicalRequestsQueue,"refreshQueueProps":_vm.refreshQueue}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }